import { DownOutlined } from "@ant-design/icons";
import { Button, Form, Popconfirm, Space, Typography } from "antd";
import { SvgIcon } from "assets/icons";
import CustomTable from "components/CustomTable";
import FormInput from "components/FormInput";
import { INPUT_TYPE } from "config/constants";
import { t } from "i18next";
import React from "react";
import GuidePopoverLink from "../GuidePopoverLink";
import VoucherConditionModal from "../VoucherConditionModal";

import { AgentPickerModal } from "../AgentPickerModal";

import { ProductPickerModal } from "../ProductPickerModal";
import ProductTargetModal from "./components/ProductTargetModal";
import TargetCustomerModal from "./components/TargetCustomerModal";

function TableProduct({
  pendingWarrantyNoteLoading,
  form,
  dataTableProduct,
  handleDeleteProduct,
  handleKeyPress,
  onAdd,
  onCopy,
  onDelete,
}) {
  // local states for customer modal and selections
  const [targetModalOpen, setTargetModalOpen] = React.useState(false);
  const [agentModalOpen, setAgentModalOpen] = React.useState(false);
  const [currentCustomerRowIndex, setCurrentCustomerRowIndex] = React.useState(null); // Riêng cho khách hàng
  const [currentProductRowIndex, setCurrentProductRowIndex] = React.useState(null); // Riêng cho sản phẩm
  const [currentVoucherRowIndex, setCurrentVoucherRowIndex] = React.useState(null); // Riêng cho voucher
  const [selectedAgentsByRow, setSelectedAgentsByRow] = React.useState({}); // { [rowIndex]: [{key,name,code}] }
  const [selectedAgentObjectsByRow, setSelectedAgentObjectsByRow] = React.useState({}); // { [rowIndex]: [full seller objects] }
  const [voucherModalOpen, setVoucherModalOpen] = React.useState(false);
  const [voucherByRow, setVoucherByRow] = React.useState({});
  const [selectedFilterTypeByRow, setSelectedFilterTypeByRow] = React.useState({}); // { [rowIndex]: 'all' | 'voucher' | 'new' | 'noapp' | 'nobill' | 'list' }
  const [productModalOpen, setProductModalOpen] = React.useState(false);
  const [productModalTypeByRow, setProductModalTypeByRow] = React.useState({}); // { [rowIndex]: 'SPECIFIC' | 'NOT_SPECIFIC' }
  const [selectedProductsByRow, setSelectedProductsByRow] = React.useState({}); // { [rowIndex]: [product objects] }
  const [productTargetModalOpen, setProductTargetModalOpen] = React.useState(false); // Modal chọn loại sản phẩm
  const [limitTypeByRow, setLimitTypeByRow] = React.useState({}); // { [rowIndex]: 'LIMITED' | 'UNLIMITED' }
  const [maxQuantityLimitTypeByRow, setMaxQuantityLimitTypeByRow] = React.useState({}); // { [rowIndex]: 'LIMITED' | 'UNLIMITED' }
  const [discountTypeByRow, setDiscountTypeByRow] = React.useState({}); // { [rowIndex]: 'DISCOUNT_PERCENTAGE' | 'DISCOUNT_MONEY' }
  const [pendingSellerSegmentID, setPendingSellerSegmentID] = React.useState(null); // Lưu sellerSegmentID khi chọn IN_GROUP

  const openTargetModal = (rowIndex) => {
    setCurrentCustomerRowIndex(rowIndex);
    setTargetModalOpen(true);
  };
  const closeTargetModal = () => setTargetModalOpen(false);

  // Product target modal functions
  const openProductTargetModal = (rowIndex) => {
    setCurrentProductRowIndex(rowIndex);
    setProductTargetModalOpen(true);
  };
  const closeProductTargetModal = () => setProductTargetModalOpen(false);

  const handleSelectProductType = (type) => {
    if (type === "INCLUDED" || type === "EXCLUDED") {
      // Mở modal chọn sản phẩm
      openProductModal(currentProductRowIndex, type);
      closeProductTargetModal();
    } else if (type === "ALL") {
      // Reset products khi chọn "Tất cả sản phẩm"
      const next = { ...selectedProductsByRow };
      delete next[currentProductRowIndex];
      setSelectedProductsByRow(next);

      // Update productModalTypeByRow để trigger re-render
      setProductModalTypeByRow({ ...productModalTypeByRow, [currentProductRowIndex]: "ALL" });

      const v = form.getFieldsValue();
      const promoOrderItems = (v.promoOrderItems || []).map((item, idx) => {
        if (idx === currentProductRowIndex) {
          return {
            ...item,
            conditionProductGroups: undefined,
          };
        }
        return { ...item };
      });
      form.setFieldsValue({ ...v, promoOrderItems });

      setTimeout(() => {
        form.validateFields([["promoOrderItems", currentProductRowIndex, "conditionProductGroups"]]);
      }, 0);

      closeProductTargetModal();
    }
  };

  const openAgentModal = (rowIndex) => {
    setCurrentCustomerRowIndex(rowIndex);
    setAgentModalOpen(true);
  };
  const closeAgentModal = () => setAgentModalOpen(false);

  const handleConfirmAgents = (selectedRows) => {
    // selectedRows từ modal là array of seller objects với id, code, fullName, etc.
    const selected = (selectedRows || []).map((seller) => ({
      key: seller.id,
      id: seller.id,
      name: seller.fullName,
      code: seller.code,
    }));
    const sellerIDs = (selectedRows || []).map((seller) => seller.id);
    const next = { ...selectedAgentsByRow, [currentCustomerRowIndex]: selected };
    setSelectedAgentsByRow(next);
    // Lưu full seller objects để hiển thị trong tab "Đã chọn"
    setSelectedAgentObjectsByRow({ ...selectedAgentObjectsByRow, [currentCustomerRowIndex]: selectedRows || [] });
    setSelectedFilterTypeByRow({ ...selectedFilterTypeByRow, [currentCustomerRowIndex]: "IN_GROUP" });

    const values = form.getFieldsValue();
    const promoOrderItems = (values.promoOrderItems || []).map((item, idx) => {
      if (idx === currentCustomerRowIndex) {
        // Preserve sellerSegmentID cũ nếu không có pendingSellerSegmentID
        const currentSellerSegmentID = item?.sellerSegmentID;
        const finalSellerSegmentID = pendingSellerSegmentID || currentSellerSegmentID || "omexnJARXqKN_1";

        // Cập nhật sellerSegmentType trong voucherGroups nếu đã có voucher
        let updatedVoucherGroups = item?.voucherGroups;
        if (updatedVoucherGroups?.length > 0) {
          updatedVoucherGroups = updatedVoucherGroups.map((group) => ({
            ...group,
            sellerSegmentType: "IN_GROUP",
            vouchers: group.vouchers?.map((voucher) => ({
              ...voucher,
              sellerSegmentType: "IN_GROUP",
            })),
          }));
        }
        return {
          ...item,
          sellerSegmentID: finalSellerSegmentID, // Preserve sellerSegmentID cũ
          sellerIDs: sellerIDs,
          selectedAgents: selected,
          voucherGroups: updatedVoucherGroups,
        };
      }
      return { ...item };
    });

    // Đảm bảo item tồn tại tại index
    if (!promoOrderItems[currentCustomerRowIndex]) {
      promoOrderItems[currentCustomerRowIndex] = {
        sellerSegmentID: pendingSellerSegmentID || "omexnJARXqKN_1",
        sellerIDs: sellerIDs,
        selectedAgents: selected,
      };
    }

    form.setFieldsValue({ ...values, promoOrderItems });
    setPendingSellerSegmentID(null); // Reset sau khi dùng
    closeAgentModal();
    closeTargetModal();
  };

  const handleSelectFilterType = (type, sellerSegmentID) => {
    if (type === "IN_GROUP") {
      setPendingSellerSegmentID(sellerSegmentID); // Lưu sellerSegmentID để dùng khi confirm agents
      openAgentModal(currentCustomerRowIndex);
    } else {
      setSelectedFilterTypeByRow({ ...selectedFilterTypeByRow, [currentCustomerRowIndex]: type });
      const values = form.getFieldsValue();
      const promoOrderItems = (values.promoOrderItems || []).map((item, idx) => {
        if (idx === currentCustomerRowIndex) {
          // Cập nhật sellerSegmentType trong voucherGroups nếu đã có voucher
          let updatedVoucherGroups = item?.voucherGroups;
          if (updatedVoucherGroups?.length > 0) {
            updatedVoucherGroups = updatedVoucherGroups.map((group) => ({
              ...group,
              sellerSegmentType: type,
              vouchers: group.vouchers?.map((voucher) => ({
                ...voucher,
                sellerSegmentType: type,
              })),
            }));
          }
          return {
            ...item,
            sellerSegmentID: sellerSegmentID,
            voucherGroups: updatedVoucherGroups,
          };
        }
        return { ...item };
      });
      form.setFieldsValue({ ...values, promoOrderItems });
      closeTargetModal();
    }
  };

  const getFilterLabel = (type) => {
    const labels = {
      ALL: "Tất cả đại lý",
      HAVE_VOUCHER_CODE: "Đại lý có vouchers",
      NEW_SELLER: "Đại lý mới",
      NOT_LOGGED_IN: "Đại lý chưa sử dụng app",
      NO_ORDER: "Đại lý chưa phát sinh đơn hàng",
      IN_GROUP: "Từ danh sách đại lý hiện có",
    };
    return labels[type] || "";
  };

  const closeVoucherModal = () => {
    setVoucherModalOpen(false);
  };

  const handleSaveVoucher = (values) => {
    const next = { ...voucherByRow, [currentVoucherRowIndex]: values };
    setVoucherByRow(next);

    // Lấy thời gian CTKM từ form chính (field period là RangePicker)
    const allFormValues = form.getFieldsValue(true);
    const campaignStartDate = allFormValues?.period?.[0]?.toISOString?.() || null;
    const campaignEndDate = allFormValues?.period?.[1]?.toISOString?.() || null;

    // Lấy sellerSegmentType từ KHÁCH HÀNG MỤC TIÊU của row hiện tại
    const currentPromoItem = allFormValues?.promoOrderItems?.[currentVoucherRowIndex];
    const sellerSegmentType =
      selectedFilterTypeByRow[currentVoucherRowIndex] || currentPromoItem?.sellerSegmentType || "ALL";

    // Xử lý timeOfUsed - nếu chọn "event" thì lấy thời gian CTKM
    const startDate =
      values?.usage?.startType === "event" ? campaignStartDate : values?.usage?.start?.toISOString?.() || null;
    const endDate = values?.usage?.endType === "event" ? campaignEndDate : values?.usage?.end?.toISOString?.() || null;

    // Xử lý effectivePeriod - nếu validType là "NONE" thì không có duration
    const isValidRuled = values?.valid?.type === "RULED";
    const effectivePeriod = {
      isSpecificTime: values?.valid?.customRangeEnabled || false,
      startAt: values?.valid?.customRange?.[0]?.toISOString?.() || null,
      endAt: values?.valid?.customRange?.[1]?.toISOString?.() || null,
      durationUnit: isValidRuled ? values?.valid?.durationUnit || "MONTH" : null,
      duration: isValidRuled ? Number(values?.valid?.duration) || 1 : null,
    };

    // Transform data từ modal sang GraphQL schema
    const voucherGroups = [
      {
        sellerSegmentType: sellerSegmentType,
        limitTimeUnit: effectivePeriod.durationUnit || "NO_LIMIT",
        limitTime: effectivePeriod.duration ?? 0,
        vouchers: [
          {
            code: values?.voucher?.code,
            sellerSegmentType: sellerSegmentType,
            timeOfUsed: {
              startDate,
              endDate,
            },
            effectivePeriod,
            // Lưu thêm startType và endType để biết voucher nào dùng "event"
            _startType: values?.usage?.startType, // "event" hoặc "specific"
            _endType: values?.usage?.endType, // "event" hoặc "specific"
          },
        ],
      },
    ];

    // Set hasVoucher = true cho row hiện tại
    const promoOrderItems = allFormValues.promoOrderItems || [];
    if (promoOrderItems[currentVoucherRowIndex]) {
      promoOrderItems[currentVoucherRowIndex] = {
        ...promoOrderItems[currentVoucherRowIndex],
        hasVoucher: true,
        voucherGroups,
      };
    } else {
      promoOrderItems[currentVoucherRowIndex] = {
        hasVoucher: true,
        voucherGroups,
      };
    }
    form.setFieldsValue({ promoOrderItems });

    setTimeout(() => {
      form.validateFields([["promoOrderItems", currentVoucherRowIndex, "hasVoucher"]]);
    }, 0);

    closeVoucherModal();
  };

  const openProductModal = (rowIndex, type) => {
    // Nếu đang có data của type khác, clear nó trước
    const currentType = productModalTypeByRow[rowIndex];
    const v = form.getFieldsValue();
    const formItems = v.promoOrderItems || [];
    const formItem = formItems[rowIndex];
    const currentConditionProductType = formItem?.conditionProductType;

    // Clear data nếu type khác với type hiện tại
    if (
      (currentType && currentType !== type) ||
      (currentConditionProductType && currentConditionProductType !== type)
    ) {
      if (selectedProductsByRow[rowIndex]) {
        const next = { ...selectedProductsByRow };
        delete next[rowIndex];
        setSelectedProductsByRow(next);
      }
      if (formItem) {
        formItem.conditionProductGroups = undefined;
        form.setFieldsValue({ ...v, promoOrderItems: formItems });
      }
    }
    setCurrentProductRowIndex(rowIndex);
    setProductModalTypeByRow({ ...productModalTypeByRow, [rowIndex]: type });
    setProductModalOpen(true);
  };

  const closeProductModal = (isSaved = false) => {
    // Luôn đóng modal trước
    setProductModalOpen(false);

    // Nếu đóng modal mà chưa có saved data (user cancel), clear value trong form
    if (
      !isSaved &&
      currentProductRowIndex !== undefined &&
      currentProductRowIndex !== null &&
      !selectedProductsByRow[currentProductRowIndex]
    ) {
      const v = form.getFieldsValue();
      const promoOrderItems = (v.promoOrderItems || []).map((item, idx) => {
        if (idx === currentProductRowIndex) {
          return {
            ...item,
            conditionProductGroups: undefined,
          };
        }
        return { ...item };
      });
      form.setFieldsValue({ ...v, promoOrderItems });
      // Clear productModalTypeByRow để không hiển thị type cũ
      const nextTypes = { ...productModalTypeByRow };
      delete nextTypes[currentProductRowIndex];
      setProductModalTypeByRow(nextTypes);
    }
  };

  const handleSaveProducts = (selectedProducts) => {
    // selectedProducts là array of product objects
    const next = { ...selectedProductsByRow, [currentProductRowIndex]: selectedProducts || [] };
    setSelectedProductsByRow(next);

    const v = form.getFieldsValue();
    const modalType = productModalTypeByRow[currentProductRowIndex];

    // Tạo conditionProductGroups theo đúng GraphQL schema
    const conditionPromotionProducts = (selectedProducts || []).map((p) => ({
      productID: p.id || p.productID,
      type: "CONDITION_PRODUCT",
    }));

    const conditionProductGroups = [
      {
        quantity: 1,
        conditionPromotionProducts,
        type: "CONDITION_PRODUCT",
        conditionProductType: modalType,
      },
    ];

    const promoOrderItems = (v.promoOrderItems || []).map((item, idx) => {
      if (idx === currentProductRowIndex) {
        return {
          ...item,
          conditionProductGroups,
        };
      }
      return { ...item };
    });

    form.setFieldsValue({ ...v, promoOrderItems });

    setTimeout(() => {
      form.validateFields([["promoOrderItems", currentProductRowIndex, "conditionProductGroups"]]);
    }, 0);

    closeProductModal(true); // Pass true to indicate this is a save action
  };

  const handleCopyRow = (index) => {
    // Call parent onCopy to handle form data and dataTableProduct
    onCopy?.(index);

    // Deep clone helper function
    const deepClone = (obj) => {
      if (obj === null || obj === undefined) return obj;
      return JSON.parse(JSON.stringify(obj));
    };

    // Clone per-row states with deep clone
    const agents = selectedAgentsByRow[index];
    const agentObjects = selectedAgentObjectsByRow[index];
    const voucher = voucherByRow[index];
    const filterType = selectedFilterTypeByRow[index];
    const products = selectedProductsByRow[index];
    const productType = productModalTypeByRow[index];
    const limitType = limitTypeByRow[index];
    const discountType = discountTypeByRow[index];
    const maxQuantityLimitType = maxQuantityLimitTypeByRow[index];

    const nextAgents = {};
    const nextAgentObjects = {};
    const nextVoucher = {};
    const nextFilterType = {};
    const nextProducts = {};
    const nextProductTypes = {};
    const nextLimitTypes = {};
    const nextDiscountTypes = {};
    const nextMaxQuantityLimitTypes = {};

    // Shift existing keys after index - deep clone each value
    Object.keys(selectedAgentsByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextAgents[keyNum] = deepClone(selectedAgentsByRow[keyNum]);
      else nextAgents[keyNum + 1] = deepClone(selectedAgentsByRow[keyNum]);
    });
    Object.keys(selectedAgentObjectsByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextAgentObjects[keyNum] = deepClone(selectedAgentObjectsByRow[keyNum]);
      else nextAgentObjects[keyNum + 1] = deepClone(selectedAgentObjectsByRow[keyNum]);
    });
    // Không deep clone voucherByRow vì chứa moment objects
    Object.keys(voucherByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextVoucher[keyNum] = voucherByRow[keyNum];
      else nextVoucher[keyNum + 1] = voucherByRow[keyNum];
    });
    Object.keys(selectedFilterTypeByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextFilterType[keyNum] = selectedFilterTypeByRow[keyNum];
      else nextFilterType[keyNum + 1] = selectedFilterTypeByRow[keyNum];
    });
    Object.keys(selectedProductsByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextProducts[keyNum] = deepClone(selectedProductsByRow[keyNum]);
      else nextProducts[keyNum + 1] = deepClone(selectedProductsByRow[keyNum]);
    });
    Object.keys(productModalTypeByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextProductTypes[keyNum] = productModalTypeByRow[keyNum];
      else nextProductTypes[keyNum + 1] = productModalTypeByRow[keyNum];
    });
    // Shift limitTypeByRow
    Object.keys(limitTypeByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextLimitTypes[keyNum] = limitTypeByRow[keyNum];
      else nextLimitTypes[keyNum + 1] = limitTypeByRow[keyNum];
    });
    // Shift discountTypeByRow
    Object.keys(discountTypeByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextDiscountTypes[keyNum] = discountTypeByRow[keyNum];
      else nextDiscountTypes[keyNum + 1] = discountTypeByRow[keyNum];
    });
    // Shift maxQuantityLimitTypeByRow
    Object.keys(maxQuantityLimitTypeByRow).forEach((k) => {
      const keyNum = Number(k);
      if (keyNum <= index) nextMaxQuantityLimitTypes[keyNum] = maxQuantityLimitTypeByRow[keyNum];
      else nextMaxQuantityLimitTypes[keyNum + 1] = maxQuantityLimitTypeByRow[keyNum];
    });

    // Copy data to new row (index + 1) - deep clone
    if (agents) nextAgents[index + 1] = deepClone(agents);
    if (agentObjects) nextAgentObjects[index + 1] = deepClone(agentObjects);
    // Copy voucher nhưng clear mã voucher (không copy mã voucher)
    if (voucher) {
      nextVoucher[index + 1] = {
        ...voucher,
        voucher: { ...voucher.voucher, code: undefined }, // Clear mã voucher
      };
    }
    if (filterType) nextFilterType[index + 1] = filterType;
    if (products) nextProducts[index + 1] = deepClone(products);
    if (productType) nextProductTypes[index + 1] = productType;
    if (limitType) nextLimitTypes[index + 1] = limitType;
    if (discountType) nextDiscountTypes[index + 1] = discountType;
    if (maxQuantityLimitType) nextMaxQuantityLimitTypes[index + 1] = maxQuantityLimitType;

    setSelectedAgentsByRow(nextAgents);
    setSelectedAgentObjectsByRow(nextAgentObjects);
    setVoucherByRow(nextVoucher);
    setSelectedFilterTypeByRow(nextFilterType);
    setSelectedProductsByRow(nextProducts);
    setProductModalTypeByRow(nextProductTypes);
    setLimitTypeByRow(nextLimitTypes);
    setDiscountTypeByRow(nextDiscountTypes);
    setMaxQuantityLimitTypeByRow(nextMaxQuantityLimitTypes);
  };

  // Cleanup state khi xóa row - shift các index sau row bị xóa
  const handleDeleteRow = (id, index) => {
    // Gọi parent handleDeleteProduct trước
    handleDeleteProduct(id, index);

    // Helper function để shift state sau khi xóa
    const shiftStateAfterDelete = (stateObj, deletedIndex) => {
      const newState = {};
      Object.keys(stateObj).forEach((k) => {
        const keyNum = Number(k);
        if (keyNum < deletedIndex) {
          // Giữ nguyên các index trước row bị xóa
          newState[keyNum] = stateObj[keyNum];
        } else if (keyNum > deletedIndex) {
          // Shift các index sau row bị xóa lên 1
          newState[keyNum - 1] = stateObj[keyNum];
        }
        // Bỏ qua index bị xóa
      });
      return newState;
    };

    // Cleanup tất cả các state theo index
    setSelectedAgentsByRow((prev) => shiftStateAfterDelete(prev, index));
    setSelectedAgentObjectsByRow((prev) => shiftStateAfterDelete(prev, index));
    setVoucherByRow((prev) => shiftStateAfterDelete(prev, index));
    setSelectedFilterTypeByRow((prev) => shiftStateAfterDelete(prev, index));
    setSelectedProductsByRow((prev) => shiftStateAfterDelete(prev, index));
    setProductModalTypeByRow((prev) => shiftStateAfterDelete(prev, index));
    setLimitTypeByRow((prev) => shiftStateAfterDelete(prev, index));
    setDiscountTypeByRow((prev) => shiftStateAfterDelete(prev, index));
    setMaxQuantityLimitTypeByRow((prev) => shiftStateAfterDelete(prev, index));
  };

  const discountTypeOptions = [
    { label: "Giảm %", value: "DISCOUNT_PERCENTAGE" },
    { label: "Giảm tiền", value: "DISCOUNT_MONEY" },
  ];

  const limitTypeOptions = [
    { label: "Có giới hạn", value: "LIMITED" },
    { label: "Không giới hạn", value: "UNLIMITED" },
  ];

  const applyToOptions = [{ label: "Giảm giá đơn hàng", value: "DISCOUNT_ORDER" }];

  const columns = [
    {
      align: "center",
      title: <span>STT</span>,
      render: (_, record, index) => index + 1,
      width: 50,
    },
    {
      title: <span>GIÁ TRỊ ĐƠN HÀNG TỐI THIỂU</span>,
      render: (_, __, index) => (
        <FormInput
          {...{
            type: INPUT_TYPE.CURRENCY_INPUT,
            formItemOptions: {
              name: [index, "minAmount"],
              rules: [
                { required: true, message: "Vui lòng nhập giá trị đơn hàng tối thiểu" },
                {
                  pattern: /^\S*$/,
                  message: "Không được nhập khoảng trắng",
                },
              ],
            },
            inputOptions: {
              maxLength: 12, // 9 số + 2 dấu chấm phân cách + 1 dấu phẩy
              className: "form-text-center form-border-radius-right",
              placeholder: "đ",
              onKeyPress: handleKeyPress,
            },
          }}
        />
      ),
    },
    {
      align: "center",
      title: <span>ƯU ĐÃI</span>,
      dataIndex: "quantity",
      render: (_, __, index) => {
        const promoOrderItems = form.getFieldValue("promoOrderItems") || [];
        const discountType = discountTypeByRow[index] || promoOrderItems[index]?.discountType || "DISCOUNT_PERCENTAGE";
        const placeholder = discountType === "DISCOUNT_PERCENTAGE" ? "%" : "đ";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center" }}>
            <FormInput
              {...{
                type: INPUT_TYPE.SELECT,
                formItemOptions: {
                  name: [index, "discountType"],
                  initialValue: "DISCOUNT_PERCENTAGE",
                  rules: [{ required: true, message: "Vui lòng chọn loại ưu đãi" }],
                },
                inputOptions: {
                  options: discountTypeOptions,
                  onChange: (value) => {
                    setDiscountTypeByRow((prev) => ({ ...prev, [index]: value }));

                    if (value === "DISCOUNT_MONEY") {
                      form.setFields([{ name: ["promoOrderItems", index, "maxDiscountAmount"], errors: [] }]);
                    }
                  },
                },
              }}
            />
            <FormInput
              {...{
                type: INPUT_TYPE.NUMBER,
                formItemOptions: {
                  name: [index, "discountAmount"],
                  rules: [{ required: true, message: "Vui lòng nhập giá trị ưu đãi" }],
                },
                inputOptions: {
                  style: { width: 90 },
                  className: "form-text-center",
                  placeholder: placeholder,
                },
              }}
            />
          </div>
        );
      },
    },
    {
      align: "center",
      title: (
        <Space direction="vertical" gap={0}>
          <Typography.Text strong style={{ fontSize: "13px" }}>
            MỨC GIẢM TỐI ĐA
          </Typography.Text>
          <span style={{ fontSize: "12px", color: "#EF9351" }}>
            (LƯU Ý: MỨC GIẢM TỐI ĐA CHỈ ÁP DỤNG CHO LOẠI GIẢM %)
          </span>
        </Space>
      ),
      render: (_, __, index) => {
        const promoOrderItems = form.getFieldValue("promoOrderItems") || [];
        const discountType = discountTypeByRow[index] || promoOrderItems[index]?.discountType || "DISCOUNT_PERCENTAGE";
        const isDiscountMoney = discountType === "DISCOUNT_MONEY";
        const limitType = limitTypeByRow[index] || promoOrderItems[index]?.limitType || "LIMITED";
        const isUnlimited = limitType === "UNLIMITED";
        const isDisabled = isDiscountMoney || isUnlimited;

        return (
          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            <FormInput
              {...{
                type: INPUT_TYPE.SELECT,
                formItemOptions: {
                  name: [index, "limitType"],
                  initialValue: "LIMITED",
                  rules: [{ required: !isDiscountMoney, message: "Vui lòng chọn" }],
                },
                inputOptions: {
                  options: limitTypeOptions,
                  disabled: isDiscountMoney,
                  onChange: (value) => {
                    setLimitTypeByRow((prev) => ({ ...prev, [index]: value }));
                    // Clear validation error khi chọn UNLIMITED
                    if (value === "UNLIMITED") {
                      form.setFields([{ name: ["promoOrderItems", index, "maxDiscountAmount"], errors: [] }]);
                    }
                  },
                },
              }}
            />
            <FormInput
              {...{
                type: INPUT_TYPE.CURRENCY_INPUT,
                formItemOptions: {
                  name: [index, "maxDiscountAmount"],
                  rules: [{ required: !isDisabled, message: "Vui lòng nhập mức giảm tối đa" }],
                },
                inputOptions: {
                  maxLength: 12,
                  min: 0,
                  style: { width: "110px" },
                  className: "form-text-center form-border-radius-right",
                  onKeyPress: handleKeyPress,
                  placeholder: "đ",
                  disabled: isDisabled,
                },
              }}
            />
          </div>
        );
      },
    },
    {
      align: "center",
      title: <span>GIÁ TRỊ GIẢM ĐƯỢC TÍNH VÀO</span>,
      render: (_, __, index) => (
        <FormInput
          {...{
            type: INPUT_TYPE.SELECT,
            formItemOptions: {
              name: [index, "type"],
              initialValue: "DISCOUNT_ORDER",
              rules: [{ required: true, message: "Vui lòng chọn" }],
            },
            inputOptions: { options: applyToOptions },
          }}
        />
      ),
    },
    {
      align: "center",
      title: <span>NGÂN SÁCH</span>,
      width: 120,
      render: (_, __, index) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FormInput
            {...{
              type: INPUT_TYPE.CURRENCY_INPUT,
              formItemOptions: {
                name: [index, "budgetAmount"],
                rules: [{ required: true, message: "Vui lòng nhập ngân sách" }],
              },
              inputOptions: {
                maxLength: 12, // 9 số + dấu phân cách
                min: 0,
                className: "form-text-center form-border-radius-right",
                placeholder: "đ",
              },
            }}
          />
        </div>
      ),
    },
    {
      align: "center",
      title: <span>SỐ LƯỢT SỬ DỤNG MỨC ƯU ĐÃI/ ĐẠI LÝ</span>,
      render: (_, record, index) => {
        const promoOrderItems = form.getFieldValue("promoOrderItems") || [];
        const maxQuantityLimitType =
          maxQuantityLimitTypeByRow[index] || promoOrderItems[index]?.maxQuantityPerSellerLimitType || "LIMITED";
        const isUnlimited = maxQuantityLimitType === "UNLIMITED";

        return (
          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            <FormInput
              {...{
                type: INPUT_TYPE.SELECT,
                formItemOptions: {
                  name: [index, "maxQuantityPerSellerLimitType"],
                  initialValue: "LIMITED",
                  rules: [{ required: true, message: "Vui lòng chọn" }],
                },
                inputOptions: {
                  options: limitTypeOptions,
                  onChange: (value) => {
                    setMaxQuantityLimitTypeByRow((prev) => ({ ...prev, [index]: value }));
                    // Clear validation error khi chọn UNLIMITED
                    if (value === "UNLIMITED") {
                      form.setFields([{ name: ["promoOrderItems", index, "maxQuantityPerSeller"], errors: [] }]);
                    }
                  },
                },
              }}
            />
            <FormInput
              {...{
                type: INPUT_TYPE.NUMBER,
                formItemOptions: {
                  name: [index, "maxQuantityPerSeller"],
                  rules: [{ required: !isUnlimited, message: "Vui lòng nhập số lượt" }],
                },
                inputOptions: {
                  maxLength: 3,
                  min: 0,
                  style: { width: "80px" },
                  className: "form-text-center form-border-radius-right",
                  onKeyPress: handleKeyPress,
                  placeholder: "0",
                  disabled: isUnlimited,
                },
              }}
            />
          </div>
        );
      },
    },
    {
      align: "center",
      title: <span>KHÁCH HÀNG MỤC TIÊU</span>,
      render: (_, __, index) => {
        // Đọc từ cả state và form để đảm bảo có data
        const formItems = form.getFieldValue("promoOrderItems") || [];
        const formItem = formItems[index];
        const agents = selectedAgentsByRow[index] || formItem?.selectedAgents || [];
        const filterType = selectedFilterTypeByRow[index] || formItem?.sellerSegmentType || formItem?.sellerSegmentID;

        const count = agents.length;
        const hasSelection = !!filterType;
        const isListType = filterType === "IN_GROUP";

        return (
          <Form.Item
            name={[index, "sellerSegmentID"]}
            rules={[{ required: true, message: "Vui lòng chọn khách hàng mục tiêu" }]}
            style={{ marginBottom: 0 }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
              <Button
                onClick={() => openTargetModal(index)}
                style={{ minWidth: 200, display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                {hasSelection ? getFilterLabel(filterType) : "Chọn khách hàng mục tiêu"}
                <DownOutlined style={{ fontSize: 12, color: "#00000040" }} />
              </Button>
              {isListType && count > 0 && (
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  Có {count} đại lý |{" "}
                  <Typography.Link onClick={() => openAgentModal(index)} style={{ fontSize: 12 }}>
                    Xem chi tiết
                  </Typography.Link>
                </Typography.Text>
              )}
            </div>
          </Form.Item>
        );
      },
    },
    {
      align: "center",
      title: <span>SẢN PHẨM ÁP DỤNG</span>,
      render: (_, __, index) => {
        // Ưu tiên đọc từ state trước, sau đó mới đọc từ form
        const formItems = form.getFieldValue("promoOrderItems") || [];
        const formItem = formItems[index];
        // Đọc conditionProductType từ trong conditionProductGroups[0]
        const formConditionProductType = formItem?.conditionProductGroups?.[0]?.conditionProductType;
        // Ưu tiên state productModalTypeByRow, nếu không có thì check form
        const currentApplyProduct = productModalTypeByRow[index] ?? formConditionProductType;
        const products = selectedProductsByRow[index] || [];
        const count = products.length;

        const getProductLabel = (type) => {
          const labels = {
            ALL: "Tất cả sản phẩm",
            INCLUDED: "Sản phẩm cụ thể",
            EXCLUDED: "Không bao gồm sản phẩm đã chọn",
          };
          return labels[type] || "";
        };

        const hasSelection = !!currentApplyProduct;

        return (
          <Form.Item
            name={[index, "conditionProductGroups"]}
            rules={[
              {
                validator: (_, value) => {
                  const modalType = productModalTypeByRow[index];
                  // Nếu chọn ALL thì pass
                  if (modalType === "ALL") {
                    return Promise.resolve();
                  }
                  // Nếu chọn INCLUDED/EXCLUDED thì phải có sản phẩm
                  if (
                    (modalType === "INCLUDED" || modalType === "EXCLUDED") &&
                    Array.isArray(value) &&
                    value.length > 0
                  ) {
                    return Promise.resolve();
                  }
                  // Nếu chưa chọn gì hoặc chọn INCLUDED/EXCLUDED nhưng chưa có sản phẩm
                  return Promise.reject(new Error("Vui lòng chọn sản phẩm áp dụng"));
                },
              },
            ]}
            style={{ marginBottom: 0 }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
              <Button
                onClick={() => openProductTargetModal(index)}
                style={{ minWidth: 200, display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                {hasSelection ? getProductLabel(currentApplyProduct) : "Chọn sản phẩm áp dụng"}
                <DownOutlined style={{ fontSize: 12, color: "#00000040" }} />
              </Button>
              {count > 0 && (
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  Có {count} sản phẩm |{" "}
                  <Typography.Link
                    onClick={() => openProductModal(index, currentApplyProduct)}
                    style={{ fontSize: 12 }}
                  >
                    Xem chi tiết
                  </Typography.Link>
                </Typography.Text>
              )}
            </div>
          </Form.Item>
        );
      },
    },
    {
      align: "center",
      title: <span>ĐIỀU KIỆN ÁP DỤNG VOUCHER</span>,
      render: (_, __, index) => {
        const saved = voucherByRow[index];
        const formItems = form.getFieldValue("promoOrderItems") || [];
        const hasVoucherValue = formItems[index]?.hasVoucher;

        return (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
            <Form.Item
              name={[index, "hasVoucher"]}
              rules={[
                {
                  validator: (_, value) => {
                    // Kiểm tra đã chọn voucher và đã nhập mã voucher
                    const voucherData = voucherByRow[index];
                    if (value === true && voucherData?.voucher?.code) {
                      return Promise.resolve();
                    }
                    if (value === true && !voucherData?.voucher?.code) {
                      return Promise.reject(new Error("Vui lòng nhập mã voucher"));
                    }
                    return Promise.reject(new Error("Vui lòng chọn điều kiện voucher"));
                  },
                },
              ]}
              style={{ marginBottom: 0, width: "100%" }}
            >
              <Button
                onClick={() => {
                  setCurrentVoucherRowIndex(index);
                  setVoucherModalOpen(true);
                }}
                style={{ minWidth: 200, display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                {saved || hasVoucherValue ? "Có voucher" : "Chọn điều kiện voucher"}
                <DownOutlined style={{ fontSize: 12, color: "#00000040" }} />
              </Button>
            </Form.Item>
            {saved && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {saved?.voucher?.code ? (
                    <span>Có 1 mã voucher | </span>
                  ) : (
                    <Typography.Text style={{ fontSize: 12, color: "#ff4d4f" }}>Chưa nhập mã voucher </Typography.Text>
                  )}
                  <Typography.Link
                    onClick={() => {
                      setCurrentVoucherRowIndex(index);
                      setVoucherModalOpen(true);
                    }}
                    style={{ fontSize: 12 }}
                  >
                    Xem chi tiết
                  </Typography.Link>
                </Typography.Text>
              </div>
            )}
          </div>
        );
      },
    },
    {
      align: "center",
      render: (_, record, index) => (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
          <Popconfirm
            title={t("warehouse.create.messageConfirmDelete")}
            cancelText={t("common.cancel")}
            okText={t("serialIE.Comfirm")}
            onConfirm={() => handleDeleteRow(record.id, index)}
          >
            <SvgIcon.TrashFullCartIcon style={{ fontSize: "16px", color: "#5B6673" }} />
          </Popconfirm>
          <SvgIcon.CopyIcon
            style={{ fontSize: "30px", cursor: "pointer" }}
            width="20px"
            height="20px"
            onClick={() => handleCopyRow(index)}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <CustomTable
        columns={columns}
        dataSource={dataTableProduct}
        rowKey={(record) => record?.id}
        title={() => (
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <GuidePopoverLink />
          </div>
        )}
        scroll={{
          x: 2000,
        }}
        loading={pendingWarrantyNoteLoading}
        footer={() => (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button type="primary" onClick={() => onAdd?.()}>
              + Thêm mức ưu đãi
            </Button>
          </div>
        )}
      />

      <TargetCustomerModal
        visible={targetModalOpen}
        onCancel={closeTargetModal}
        onSelect={handleSelectFilterType}
        currentType={selectedFilterTypeByRow[currentCustomerRowIndex]}
      />

      <AgentPickerModal
        visible={agentModalOpen}
        onCancel={closeAgentModal}
        onOk={handleConfirmAgents}
        initialSelectedRowKeys={(selectedAgentsByRow[currentCustomerRowIndex] || []).map((a) => a.id || a.key)}
        initialSelectedRows={selectedAgentObjectsByRow[currentCustomerRowIndex] || []}
      />

      <VoucherConditionModal
        visible={voucherModalOpen}
        onCancel={closeVoucherModal}
        onSave={handleSaveVoucher}
        initialValues={voucherByRow[currentVoucherRowIndex]}
      />

      <ProductPickerModal
        visible={productModalOpen}
        onCancel={closeProductModal}
        onOk={handleSaveProducts}
        title={
          productModalTypeByRow[currentProductRowIndex] === "SPECIFIC"
            ? "Chọn sản phẩm áp dụng"
            : productModalTypeByRow[currentProductRowIndex] === "NOT_SPECIFIC"
              ? "Chọn sản phẩm không áp dụng"
              : "Chọn sản phẩm"
        }
        initialSelectedProducts={selectedProductsByRow[currentProductRowIndex] || []}
        modalType={productModalTypeByRow[currentProductRowIndex]}
      />

      <ProductTargetModal
        visible={productTargetModalOpen}
        onCancel={closeProductTargetModal}
        onSelect={handleSelectProductType}
        currentType={form.getFieldValue(["items", currentProductRowIndex, "applyProduct"])}
      />
    </>
  );
}

export default TableProduct;
